/* ============================================================
   Shared CarePlix retail API config.
   The api_key is sent in the body of every auth request.
   ============================================================ */
export const API_KEY = "CNCPsuS7pXa44NmBq8Hv";

// ⚠️ staging host
const AUTH_BASE = "https://retail-api-stage-sdk-wrapper-app.carenow.healthcare";

export const SEND_OTP_URL = `${AUTH_BASE}/auth/send-otp`;
export const SIGN_IN_URL = `${AUTH_BASE}/auth/sign-in`;
